import React from 'react';

const AIMagicButton = ({ colorName, onTriggerMagic }) => {
  return (
    <div className="flex flex-col items-center justify-center py-8 px-6 font-light">
      {/* Magic Button */}
      <button
        onClick={onTriggerMagic}
        className="group relative overflow-hidden bg-gradient-to-r from-purple-600 via-pink-600 to-rose-600 hover:from-purple-700 hover:via-pink-700 hover:to-rose-700 text-white font-semibold py-3 px-6 rounded-2xl shadow-2xl transform hover:scale-105 transition-all duration-300 animate-pulse hover:animate-none"
      >
        {/* Sparkle overlay */}
        <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/20 to-transparent transform -skew-x-12 -translate-x-full group-hover:translate-x-full transition-transform duration-1000"></div>
        
        {/* Button content */}
        <div className="relative flex items-center space-x-2">
          <span className="text-xl animate-bounce">🤖</span>
          <span className="text-base">Unleash AI Color Magic</span>
          <span className="text-xl animate-bounce" style={{animationDelay: '0.5s'}}>✨</span>
        </div>
      </button>
      
      {/* Description */}
      <div className="text-center mt-6 space-y-2">
        <p className="text-base font-medium text-gray-700">
          Discover magical wedding ideas for <span className="text-rose-600 font-semibold">{colorName}</span>
        </p>
        <p className="text-sm text-gray-500 italic font-light">
          ✨ AI will craft personalized suggestions across 6 wedding categories ✨
        </p>
      </div>
      
      {/* Feature highlights */}
      <div className="flex flex-wrap justify-center gap-3 mt-6">
        <div className="flex items-center space-x-1 bg-purple-50 px-3 py-1 rounded-full">
          <span className="text-sm">🏺</span>
          <span className="text-xs text-purple-700 font-medium">Decor</span>
        </div>
        <div className="flex items-center space-x-1 bg-pink-50 px-3 py-1 rounded-full">
          <span className="text-sm">🌸</span>
          <span className="text-xs text-pink-700 font-medium">Flowers</span>
        </div>
        <div className="flex items-center space-x-1 bg-rose-50 px-3 py-1 rounded-full">
          <span className="text-sm">👗</span>
          <span className="text-xs text-rose-700 font-medium">Attire</span>
        </div>
        <div className="flex items-center space-x-1 bg-yellow-50 px-3 py-1 rounded-full">
          <span className="text-sm">💡</span>
          <span className="text-xs text-yellow-700 font-medium">Lighting</span>
        </div>
        <div className="flex items-center space-x-1 bg-blue-50 px-3 py-1 rounded-full">
          <span className="text-sm">💌</span>
          <span className="text-xs text-blue-700 font-medium">Stationery</span>
        </div>
        <div className="flex items-center space-x-1 bg-green-50 px-3 py-1 rounded-full">
          <span className="text-sm">🍰</span>
          <span className="text-xs text-green-700 font-medium">Food & Cake</span>
        </div>
      </div>
    </div>
  );
};

export default AIMagicButton;
